const lang = {
  challenge: {
    detail: {
      chall_detail_parti: "Participants",
      chall_detail_reward: "Récompenses",
      chall_detail_reward_item: "Articles",
      chall_detail_reward_badges: "Badges",
      chall_detail_reward_badge: "Badges",
      chall_detail_reward_point: "Points",
      chall_detail_goal: "Objectif",
      chall_detail_dist: "Distance",
      chall_detail_workout: "Entraînement",
      chall_detail_workout_detail: "Entraînements éligibles",
      chall_detail_intro: "Présentation",
      chall_detail_rank: "Classement",
      chall_detail_btn_join: "Participer",
      chall_detail_time: "Fin dans",
      chall_detail_time_days: "Jours",
      chall_detail_status_my: "Mon statut",
      chall_detail_status_team: "Statut de l'équipe",
      chall_detail_status_rank: "Classement",
      chall_detail_status_progress: "Progression",
      chall_detail_status_duration: "Durée",
      chall_detail_status_dist: "Distance",
      chall_detail_status_cal: "Calories",
      common_steps_low: "Pasos",
      common_rep_count: "Répétitions",
      chall_detail_status_day: "Jours d'entraînement",
      chall_detail_status_best: "Meilleur résultat",
      chall_detail_status_contribution: "Ma contribution",
      chall_detail_btn_try: "Réessayer",
      chall_detail_btn_start: "Démarrer le défi",
      chall_detail_btn_continue: "Poursuivre le défi",
      chall_detail_btn_expired: "Défi expiré",
      chall_detail_reward_item_claim: "Obtenir",
      chall_detail_reward_badge_display: "Afficher",
      chall_detail_toast_unstart: "Défi non démarré",
      chall_detail_toast_end: "Défi terminé",
      chall_detail_rank_empty:
        "Aucune donnée de classement, démarrez votre défi et actualisez le classement.",
      chall_detail_workout_collection_mt: "Collection Spécifique",
      chall_detail_workout_route: "Infos sur l'Itinéraire",
      chall_detail_reward_mt: "Récompenses",
      chall_detail_workout_outrun: "Course en extérieur",
      chall_detail_workout_outcycle: "Cyclisme en extérieur",
      chall_detail_workout_outwalk: "Marche en extérieur",
      chall_detail_workout_yoga: "Yoga",
      chall_detail_workout_cardio: "Cardio",
      chall_detail_workout_strength: "Force",
      chall_detail_workout_stretch: "Étirements",
      chall_detail_workout_run: "Tapis roulant",
      chall_detail_workout_cycle: "Cyclisme",
      chall_detail_workout_row: "Rameur",
      chall_detail_workout_ellipt: "Vélo elliptique",
      chall_detail_workout_step: "Stepper",
      chall_detail_workout_rnr: "Row-N-Ride",
      chall_detail_workout_minibike: "Mini vélo",
      chall_detail_workout_ski: "Machine à ski",
      chall_detail_workout_jump: "Corde à sauter",
      chall_detail_workout_vibration_treadmill: "Tapis de course vibrant",
      chall_detail_product_recommend: "Recommandation de produits",
      chall_detail_version_update_note: "Cette version ne prend pas en charge cette fonctionnalité. Veuillez mettre à jour.",
      chall_detail_workout_stair: "Escalier d'entraînement",
      chall_detail_workout_slider: "Grimpeur à glissière",

      chall_detail_workout_runcour: "Cours running",
      chall_detail_workout_cyclecour: "Cours cyclisme",
      chall_detail_workout_elliptcour: "Cours elliptiques",
      chall_detail_workout_rowcour: "Cours d’aviron",
      chall_detail_workout_stepcour: "Cours stepper",
      chall_detail_workout_prenatal: "Cours prénataux",
      chall_detail_workout_postpartum: "Cours post-partum",
      chall_detail_workout_meditation: "Cours méditation",
      chall_detail_workout_rnrcourses: "Cours Row-N-Ride",
      chall_detail_workout_audio: "Cours audio",
      chall_detail_workout_pilates: "Pilates",
      chall_detail_workout_climber: "Parcours d'escalade",

      chall_detail_workout_all:
        "Tous les entraînements suivis par l'application SunnyFit.",
      chall_detail_workout_collection:
        "Entraînez-vous avec des cours de cette collection",
      chall_detail_goal_intro:
        "Faites de l'exercice pendant {times} jours, {value} {type} par jour.",
      chall_detail_team_join_mt: "Rejoindre une équipe",
      chall_detail_team_create: "Créer une équipe",
      chall_detail_team_join_conf: "Rejoindre une équipe",
      chall_detail_team_create_cxl: "Annuler",
      chall_detail_team_create_conf: "Enregistrer",
      chall_detail_team_user_follow: "Suivre",
      chall_detail_team_user_assign: "Nommer capitaine",
      chall_detail_team_user_remove: "Retirer de l'équipe",
      chall_detail_team_leave: "Quitter l'équipe",
      chall_detail_team_user_following: "Suivis",
      chall_detail_team_leave_note:
        "Voulez-vous vraiment quitter cette équipe ?",
      chall_detail_team_leave_cxl: "Annuler",
      chall_detail_team_leave_conf: "Confirmer",
      chall_detail_team_me: "Moi",
      chall_detail_team_leave_toast:
        "Veuillez attribuer le rôle de capitaine à l'un des membres de votre équipe.",
      chall_detail_team_join_toast: "Veuillez sélectionner une équipe",
      chall_detail_team_join_toast_full:
        "L'équipe que vous avez sélectionnée est au complet. Veuillez sélectionner une autre équipe ou créer la vôtre.",
      chall_detail_team_create_toast: "Veuillez saisir le nom de votre équipe.",
      chall_detail_result_descrip_goal_com_1: "Félicitations !",
      chall_detail_result_descrip_goal_com_single:
        "Vos efforts ont porté leurs fruits. Continuez sur cette lancée !",
      chall_detail_result_descrip_goal_com_team:
        "Les efforts de votre équipe ont porté leurs fruits. Continuez sur cette lancée !",
      chall_detail_result_descrip_goal_incom_1: "Continuez comme ça ! 💪",
      chall_detail_result_descrip_goal_incom_2:
        "Soufflez, recentrez-vous et affrontons le défi suivant ensemble !",
      chall_detail_result_descrip_other1_1: "Ouah, vous êtes au top !",
      chall_detail_result_descrip_other1_single:
        "Votre dévouement a porté ses fruits. Continuez de montrer la voie et d'inspirer les autres !",
      chall_detail_result_descrip_other1_team:
        "Le dévouement de votre équipe a porté ses fruits. Continuez de montrer la voie et d'inspirer les autres !",
      chall_detail_result_descrip_other2_1: "Beau travail !💪",
      chall_detail_result_descrip_other2_single:
        "Vous êtes en {rank} place ! Génial !",
      chall_detail_result_descrip_other2_team:
        "Votre équipe est en {rank} place !\nGénial !",
      chall_detail_result_descrip_other3_single:
        "Vous êtes à la {rank} place !",
      chall_detail_result_descrip_other3_team:
        "Votre équipe est à la {rank} place !",
      chall_detail_result_descrip_other3_2:
        "Continuez comme ça et visez un rang encore plus élevé la prochaine fois !",
      chall_detail_result_reward: "Récompenses reçues",
      chall_detail_result_done: "Terminé",
      chall_detail_result_share: "Partager",
      chall_detail_result_reward_badge: "Badges",
      chall_detail_result_reward_point: "Points",
      chall_detail_result_reward_item: "Articles",
      chall_detail_workout_collection_time: "Durée estimée",
      chall_detail_start_workout: "Démarrer un entraînement",
      badge_detail_display: "Afficher sur le profil",
      badge_detail_remove: "Supprimer du profil",
      badge_detail_display_toast: "Maintenant affiché sur votre profil",
      badge_detail_remove_toast: "N'est plus affiché sur votre profil",
      invite_from: "Invitation de",
      invite_from_friend: "Amis",
      invite_from_contact: "Contacts",
      invite_from_more: "Plus",
      address_edit_mt: "Adresse de livraison",
      address_edit_note: "Toutes les données seront chiffrées",
      address_edit_country: "Pays / région",
      address_edit_name: "Nom",
      address_edit_street: "Adresse postale",
      address_edit_apt: "Appartement/suite/autre (facultatif)",
      address_edit_city: "Ville",
      address_edit_state: "Département",
      address_edit_code: "Code postal",
      address_edit_phone: "Numéro de téléphone",
      address_edit_btn: "Envoyer",
      address_edit_state_select_mt: "Sélectionner le département",
      address_edit_check: "Vérifier l'adresse",
      address_edit_check_note:
        "Veuillez vérifier l'adresse pour assurer une livraison correcte. Les prix perdus ne seront pas remplacés.",
      address_edit_check_cxl: "Annuler",
      address_info_mt: "Adresse de livraison",
      address_info_name: "Nom",
      address_info_phone: "Numéro de téléphone",
      address_info_address: "Adresse",
      common_courses_count: "Cours",
      challenge_exchange_title1: 'Êtes-vous intéressé à dépenser ',
      challenge_exchange_title2: ' points pour rejoindre ?',
      challenge_exchange_mypt: 'Mes Points:',
      challenge_exchange_button1: 'Rejoindre avec %s points',
      challenge_exchange_button2: 'Gagner plus de points',
      challenge_exchange_button3: 'Annuler',
      challenge_exchange_toast: 'Inscription réussie',
      
      chall_detail_workout_select_route: 'Sélectionnez un itinéraire.',
      chall_detail_workout_route_select: 'Sélectionnez cet itinéraire',
      chall_detail_workout_change_route: 'Changer',
      chall_detail_workout_my_route: 'Mon itinéraire',
      chall_detail_status_scoring_rules: 'Règles de score',

      chall_scoring_rules_main_title: "Comment marquer des points 🏆",
      chall_scoring_rules_goal_title: "🏁 Objectif atteint (s% pts)",
      chall_scoring_rules_goal_descrip: "Atteignez la distance cible pour sécuriser vos points d'objectif.\nStatut : Gagné immédiatement dès que la distance est atteinte.",
      chall_scoring_rules_speed_title: "⚡ Bonus de vitesse (max s% pts)",
      chall_scoring_rules_speed_descrip: "Plus vous finissez vite, plus votre score est élevé ! Votre bonus de vitesse est calculé au moment exact où vous atteignez la distance cible.\nAstuce : Temps de fin plus court = Rang plus élevé.",
      chall_scoring_rules_bonus_title: "🎯 Bonus de régularité (max s% pts)",
      chall_scoring_rules_bonus_descrip: "La régularité paye ! Gagnez +1 point supplémentaire chaque fois que vous répétez ce défi (jusqu'à s% pts).",
      chall_scoring_rules_ranking_title: "🥇 Règles de classement",
      chall_scoring_rules_ranking_descrip: "Score total : Votre score final = Objectif + Vitesse + Bonus (plafonné à 100 pts).\nVerrouillage : Les scores sont verrouillés dès que vous atteignez l'objectif. Continuer à bouger sert uniquement au suivi de l'exercice et ne changera pas votre rang.\nÉgalité : Si les scores sont égaux, le temps de fin le plus rapide l'emporte.",
      
      share_challenge_poster_bub: '🔥 Rejoignez-moi dans ce défi ! 🏆️',
      share_poster_sologn: 'Fit gratuit, grandis avec Sunny Fam 👉',
      share_poster_challenge_success: 'Défi et Succès',

      common_block_pop_title: "Usage Limité",
      chall_detail_join_limit_content: 'En raison de la détection d’un comportement anormal de collecte de données, et afin d’assurer l’équité de la communauté, vos fonctions de Défi ont été restreintes.',
      me_contact: 'Nous contacter',
    },
  },
  workout: {
    collection: {
      detail: {
        workout_course_collection_detail_mt: "Collection",
        workout_wt_collection_detail_mt: "Collection de tours du monde",
        workout_course_collection_detail_count: "Cours",
        workout_course_collection_detail_limit: "Cours à durée limitée",
      },
    },
  },
  support: {
    equipment: {
      detail: {
        equip_support_equip_main: "Équipement de soutien",
        equip_support_equip_enter_tips:
          "Veuillez entrer le modèle de votre équipement:",
        equip_support_equip_enter_content: "Entrer le modèle...",
        equip_support_equip_tips_main: "Conseils",
        equip_support_equip_tips_content:
          "Si vous ne connaissez pas le modèle de l'appareil, vous pouvez vérifier l'étiquette du corps, comme indiqué dans l'image ci-dessous.",
        equip_support_equip_contact_us_btn: "Nous contacter",
        equip_support_equip_view_courses_btn: "Voir les cours",
        btn_common_ok: "OK",
        btn_common_search: "Chercher",
      },
    },
  },
  contact: {
    detail: {
      contact_us_mt: "Nous contacter",
      contact_us_feedback: "Envoyer des commentaires",
      contact_us_note:
        "Faites-nous part de vos commentaires ou de vos problèmes, et nous reviendrons vers vous dans les 2 jours ouvrés !",
      contact_us_issue_type: "J'ai besoin d'aide avec",
      contact_us_issue_type_input: "Veuillez sélectionner votre problème",
      contact_us_name: "Nom complet",
      contact_us_name_input: "Saisissez votre nom complet ici",
      contact_us_equip: "Modèle d'équipement",
      contact_us_equip_input: "Saisissez le # du modèle de l'équipement",
      contact_us_email: "Adresse e-mail",
      contact_us_email_input: "Saisissez votre adresse e-mail ici",
      contact_us_describe: "Décrivez votre problème",
      contact_us_describe_input: "Laissez votre message ici",
      contact_us_image: "Pièce jointe Image/Vidéo",
      contact_us_contact_info: "Informations de contact",
      btn_common_send: "Envoyer",
      btn_common_submit: "Submit",
      contact_us_issue_type_mt: "Type de problème",
      contact_us_issue_type_equip: "Problèmes d'équipement",
      contact_us_issue_type_equip_note:
        "Problème de compteur / Pièces endommagées/manquantes",
      contact_us_issue_type_app: "Problèmes avec l'application",
      contact_us_issue_type_app_note: "Fonctionnalités/Expérience utilisateur",
      contact_us_issue_type_suggest: "Suggestions",
      contact_us_issue_type_suggest_note:
        "Ajouter des cours / Ajouter des fonctionnalités",
      contact_us_issue_type_equip_meter: "Problème de compteur",
      contact_us_issue_type_equip_damage: "Pièce(s) manquante(s)/endommagée(s)",
      contact_us_issue_type_app_regist: "Inscription/Connexion",
      contact_us_issue_type_app_connect: "Connexion Bluetooth",
      contact_us_issue_type_app_googlefit: "Google Fit",
      contact_us_issue_type_app_applehealth: "Apple Santé",
      contact_us_issue_type_app_video: "Lecture vidéo/audio",
      contact_us_issue_type_app_plan: "Plans et cours/programmes planifiés",
      contact_us_issue_type_app_account: "Compte et profil",
      contact_us_issue_type_app_update: "Mise à jour de la version",
      contact_us_issue_type_app_data: "Données anormales",
      contact_us_issue_type_app_other: "Autres problèmes avec l'application",
      contact_us_issue_type_app_wifi: "Connexion Wi-Fi",
      contact_us_result_mt: "Merci pour vos commentaires !",
      contact_us_result_st:
        "Nous reviendrons vers vous dans les 2 jours ouvrés.",
      btn_common_done: "Terminé",
      btn_common_next: "Suivant",
      
      btn_common_camera: "Caméra",
      btn_common_photo_album: "Choisir photo de l'album",
      btn_common_video_album: "Choisir une vidéo de l'album",
      btn_common_cancel: "Annuler",

      camera_note_main: "Autorisation caméra",
      camera_note_content: "Nous avons besoin d'accéder à votre caméra pour télécharger du contenu.",
      photo_note_main: "Autorisation photo",
      photo_note_content:
        "Nous avons besoin d'accéder à vos photos pour télécharger du contenu.",

      photo_note_btn_open_settings: "Ouvrir les paramètres",
      uploading_note_main: "Téléchargement de vos commentaires...",
      uploading_note_schedule: "{currentUploadIndex} sur {totalUploadCount} fichiers téléchargés",
      uploading_note_tips: "Le fichier vidéo peut prendre plus de temps",

      album_attach_upload_failed_toast: "Échec du téléchargement. Réessayez.",
      album_attach_image_toast: "Vous pouvez joindre jusqu'à {number} images",
      album_attach_image_length_toast: "Vous pouvez sélectionner des images de moins de {size} Mo chacune",
      album_attach_video_toast: "Vous pouvez joindre jusqu'à {number} vidéos",
      album_attach_video_length_toast1: "Veuillez sélectionner une vidéo dans les {number} secondes.",
      album_attach_video_size_toast: "Veuillez sélectionner une vidéo dans les {number} Mo.",

    },
  },
  workoverview: {
    detail: {
      common_steps: "Pas",
      common_steps_low: "pas",
      workout_result_mt: "Données d'entraînement",
      workout_result_cal_in: "Les calories dans",
      workout_result_hamburger: "Hamburger",
      workout_result_hamburger_note:
        "Un {name} équivaut à environ {value} calories",
      workout_result_data_time: "Durée",
      workout_result_data_dis: "Distance",
      workout_result_data_cal: "Calories",
      workout_result_data_height: "Hauteur",
      workout_result_data_floors: "Étages",
      workout_result_data_cal_note:
        "Les calories brûlées affichées sur votre application sont basées sur votre taille et votre poids, elles peuvent donc être différentes des données de votre équipement.",
      workout_result_data_floor_note: "Un étage fait environ 2.5 mètres.",
      workout_result_data_steps: "pas",
      workout_result_data_stroke: "Battements",
      workout_result_data_stride: "Nombre de pas",
      workout_result_data_max_jumps: "Sauts Maximum",
      workout_result_data_avg: "Moy.",
      workout_result_data_max: "Max.",
      workout_result_data_rep: "Répétitions",
      workout_result_data_reps: "Répétitions",
      workout_result_data_hr: "Rythme cardiaque",
      workout_result_evaluate: "Évaluer",
      workout_result_data_hr_analysis: "Analyse cardiaque",
      workout_result_data_hr_zone: "Zone {index}",
      workout_result_data_speed: "Vitesse",
      workout_result_data_pace: "Rythme",
      workout_result_pace_fast: "Rapide",
      workout_result_data_resist: "Résistance",
      workout_result_data_cadence: "Cadence",
      workout_result_data_spm: "SPM",
      workout_result_data_str: "Taux de battement",
      workout_result_post: "Publier mon résultat",
      workout_result_share_video: "Partager une super vidéo",
      workout_result_wu: "Échauffement",
      workout_result_main: "Principal",
      workout_result_cd: "Récupération",
      workout_result_treadmill: "Entraînement sur tapis roulant",
      workout_result_bike: "Vélo d'intérieur",
      workout_result_elliptical: "Entraînement sur elliptique",
      workout_result_rnr: "Entraînement de rame et de ride",
      workout_result_rower: "Entraînement sur rameur",
      workout_result_stepper: "Entraînement sur stepper",
      workout_result_data_incline: "Inclinaison",
      workout_result_run: "Course à pied en extérieur",
      workout_result_walk: "Marche en extérieur",
      workout_result_cycling: "Vélo en extérieur",
      workout_result_result_workout: "Nombre",
      workout_result_chall_score: "Score",
      workout_result_map_hide_note:
        "La carte sera masquée lorsque vous partagerez.",
      workout_result_on_equipment: "Sur l'équipement",
      workout_result_off_equipment: "Hors de l'équipement",
      btn_common_done: "Terminé",
      btn_common_share: "Partager",
      btn_common_try_again: "Réessayer",
      common_completed: "Terminé",
      common_remaining: "Restant",
      share_common_open: "Ouvrir",
      social_user_follow: "Suivre",
      social_user_following: "Suivis",
      share_common_join_us: "Rejoignez-nous",
      workout_result_movement_tag: "Mouvement",
      workout_result_movement_note: "Cet entraînement de mouvements est personnalisé à partir du plan AI. Voulez-vous créer votre plan exclusif ?",
      btn_try_now: "Essayez maintenant",
      workout_result_share: 'Share My Result',
      workout_result_movement_feedback: "Avis",
      workout_result_movement_feedback_mt: "Vos retours nous aident à nous améliorer",
      workout_result_movement_feedback_tip: "Que penses-tu de cet entraînement ?",
      btn_common_submit: "Envoyer",
    },
  },
  midYearReport: {
    workoutData_burnCalories: "Total des calories brûlées",
    workoutData_workoutTimes: "Total #  Entraînements",
    workoutData_workoutDays: "Jours d'entraînement",
    workoutData_workoutDuration: "Durée d'entraînement",

    community_title:
      "Merci d'avoir contribué et d' être partie de la communauté SunnyFit !",
    community_friendsRanking: "Classement parmi les amis",
    community_rankOpen: "Top ",
    community_rankEnd: " parmi les amis",
    community_postShares: "Partages de publications",
    community_likesReceived: "Publications aimées",
    community_share_unit: "Partages",
    community_like_unit: "Aimées",

    // favoriteWorkout_title: "Entraînement favori",
    favoriteWorkout_totalNumberOfWorkouts: " Entrainements complétés",
    favoriteWorkout_equivalentToSeveralBurgers: "Calories brûlées équivalent à",
    favoriteWorkout_totalDistance_Metric: "Distance totale en kilomètres",
    favoriteWorkout_totalDistance_Imperial: "Distance totale en miles",
    favoriteWorkout_MaxRPMAchieved: "RPM Max Atteints",
    favoriteWorkout_MaxSPMAchieved: "SPM Max Atteints",
    favoriteWorkout_TotalDuration: "Durée totale",
    favoriteWorkout_TotalCaloriesBurned: "Calories brûlées",
    favoriteWorkout_fastestPace: "Votre rythme le plus rapide réalisé",
    favoriteWorkout_fastestCadence: "Votre cadence la plus rapide accomplie ",
    favoriteWorkout_maxStrokes: "Votre allure la plus rapide réalisée",
    favoriteWorkout_maxFrequency: "Votre cadence la plus rapide accomplie",
    favoriteWorkout_totalDaysOfWorkout: "Jours totaux d'entraînements de &*& ",

    favorite_favorite: "Favorite",
    favoriteTrainer_descTime:
      "Au cours des six derniers mois, vous avez suivi des cours de sport avec &*& entraîneurs de Sunny.",
    favoriteTrainer_descTrain:
      "Vous avez suivi &*& cours avec votre entraîneur préféré, &*& !",

    favoriteCourses_title:
      "De nouveaux cours sont ajoutés à SunnyFit chaque semaine !",
    favoriteCourses_coursesDesc: "Cela équivaut à regarder &*& films !",

    noData_title: "Rapport d'entraînement SunnyFit",
    noData_info: "Les données d'entraînement que vous avez fournies pour 2024 ne sont pas suffisantes.",

    common_share: "Partager",
    common_back: "Retour",
    common_joinNow: "Rejoignez Maintenant",
    common_update: "Veuillez mettre à jour vers la dernière version.",
  },
  pointsMall:{
    product:{
      detail: {
        "product_detail_top_title":"Détails du produit",
        "product_detail_mypoints":"Mes points:",
        "product_detail_exchange":"Échanger",
        "product_detail_earn":"Gagner plus de points",
        "product_detail_stock":"En rupture de stock",
        "product_detail_null_title":"Les données sont anormales, veuillez réessayer plus tard.",
        "product_detail_null_button":"Actualiser",
        "product_detail_promotional1": "Fin Limitée %s jours",
        "product_detail_promotional2": "Limité | Seulement %s Restants",
        "product_detail_promotional3": "Limité | Épuisé",
        "product_detail_gift_others": "Cadeau pour les Autres",
        "product_detail_gift_myself": "Cadeau pour Moi"
      }
    },
    order:{
      detail: {
        "exchange_detail_my_order_title":"Ma commande",
        "exchange_detail_view_points":"Mes points",
        "exchange_detail_discount": "Remise",
        "exchange_detail_expected_deduction":"Déduction prévue",
        "exchange_detail_balance":"Solde",
        "exchange_detail_out_of_stock":"Nous sommes actuellement en rupture de stock pour cet article. Veuillez revenir plus tard.",
        "exchange_detail_redemption_toast":"Le remboursement dépasse la limite.",
        "exchange_detail_confirm_exchange":"Confirmer l'échange",

        "exchange_successful_title":"Rachat réussi",
        "exchange_successful_goods_send_info":"Ton article sera expédié bientôt. Tu peux vérifier l'avancement dans les détails de ta commande.",
        "exchange_successful_check_order_detail":"Pour commencer le processus de rachat, veuillez vérifier les détails de votre commande.",
        "exchange_successful_back":"Retour",
        "exchange_successful_view":"Voir les détails de la commande",

        "orders_history_detail_address_title1":"Téléphone",
        "orders_history_detail_address_title2":"Adresse",
        "orders_history_detail_address_title3":"Email",
        "orders_history_null_title": "Il est vide ici",
        "address_detail_add_shipping_address":"Ajouter l'adresse d'expédition",
        "address_detail_add":"Ajouter",
        "address_detail_default":"Par défaut",
        "address_detail_set_as_default":"Comme par défaut",
        "address_detail_my_address":"Mon adresse",
        "address_detail_delete":"Supprimer",
        "address_detail_edit":"Modifier",
        "address_detail_add_a_shipping_address":"+ Ajouter une adresse d'expédition",
        "address_detail_delete_tips":"Conseils de suppression",
        "address_detail_toast":"Êtes-vous sûr de supprimer cette adresse?",
        "address_detail_cancel":"Annuler",
        "address_detail_delete":"Supprimer",

        "shipping_address_title":"Adresse d'expédition",
        "shipping_address_data_encryption_info":"Toutes les données seront chiffrées",
        "shipping_address_country_region":"Pays/Région",
        "shipping_address_first_name":"Prénom",
        "shipping_address_first_name_prompt":"Veuillez saisir votre prénom",
        "shipping_address_last_name":"Nom de famille",
        "shipping_address_last_name_prompt":"Veuillez saisir votre nom de famille",
        "shipping_address_address_line_1":"Ligne d'adresse 1",
        "shipping_address_address_line_1_desc":"Nom de la rue et numéro de la rue, nom de l'entreprise",
        "shipping_address_address_line_2":"Ligne d'adresse 2",
        "shipping_address_address_line_2_sub":"(Optionnel) ",
        "shipping_address_address_line_2_desc":"Bâtiment/Appartement/Suite n°, Unité, Étage, etc",
        "shipping_address_state":"État",
        "shipping_address_state_prompt":"Veuillez sélectionner l'État",
        "shipping_address_city":"Ville",
        "shipping_address_city_prompt":"Veuillez saisir votre ville",
        "shipping_address_zip_code":"Code postal",
        "shipping_address_zip_code_prompt":"Veuillez saisir le code postal",
        "shipping_address_phone_number":"Numéro de téléphone",
        "shipping_address_phone_number_prompt":"Veuillez saisir votre numéro de téléphone",
        "shipping_address_email_address":"Adresse e-mail",
        "shipping_address_email_address_desc":"Pour recevoir des informations d'expédition",
        "shipping_address_security_privacy_info":"Sécurité et Vie privée",
        "shipping_address_security_privacy_desc":"Nous maintenons des mesures physiques, techniques et administratives conformes aux normes de l'industrie pour protéger vos informations personnelles.",
        "shipping_address_save":"Enregistrer",
        "shipping_address_name":"Veuillez saisir votre prénom et nom de famille avec 2 à 32 caractères.",
        "shipping_address_toast":"Nous nous excusons, mais notre programme de rédemption de points est actuellement disponible uniquement pour les utilisateurs des 48 États contigus des États-Unis.",

        "orders_history_top_title":" Historique commandes",
        "orders_history_list_view":"Voir les détails",
        "orders_history_list_date":"Date d'échange:",
        "orders_history_null_button":"Échange de points",
        "orders_history_detail_top_title":"Détail de la commande",
        "orders_history_detail_tracking_title":"Numéro de suivi",
        "orders_history_detail_coupon_code":"Code promo",
        "orders_history_detail_coupon_time":"Date d’expiration du coupon",
        "orders_history_detail_tracking_state":"Traitement",
        "ordershi_history_detail_date_title":"Date d'échange",
        "orders_history_detail_spend_title":"Dépense",
        "orders_history_detail_order_title":"Numéro de commande",
        "orders_history_detail_instructions":"Instructions",
        "orders_history_detail_copy":"Copier",
        "orders_history_detail_copy_toast":"La copie a été effectuée avec succès",
        "orders_history_tab_1":"Commandes d'échange",
        "orders_history_tab_2":"Commandes de cours",

      "invite_reward_order_type":"Bonus Ami",
      "event_reward_order_type":"Prix de l'événement",
      
      "rewards_points_toast_error200": "Commande créée avec succès",
      "rewards_points_toast_error302": "Promotion invalide",
      "rewards_points_toast_error404": "Les données sont anormales, veuillez réessayer plus tard.",
      "rewards_points_toast_error412": "Les données sont anormales, veuillez réessayer plus tard.",
      "rewards_points_toast_error999": "Les données sont anormales, veuillez réessayer plus tard.",
      "rewards_points_toast_error14001": "Article discontinué",
      "rewards_points_toast_error14002": "Nous sommes actuellement en rupture de stock pour cet article. Veuillez revenir plus tard.",
      "rewards_points_toast_error14003": "Points insuffisants",
      "rewards_points_toast_error14004": "Échange dépasse la limite",
      "rewards_points_toast_error14005": "Pas dans la période de promotion",
      "rewards_points_toast_error14006": "Échange limité de la promotion épuisé",
      "rewards_points_toast_error14008": "Le cadeau a déjà été réclamé",
      "rewards_points_toast_error14010": "Dépassé le délai de réclamation – Le cadeau a été retourné",
      }
    },
  },
  common: {
    common_no_content: "Aucun contenu",
    common_loading_failed: "Échec du chargement",
    common_refresh: "Actualiser",
    common_loading: "Chargement",
    common_points: "Points",
    common_intensity_beg: "Débutant",
    common_intensity_int: "Intermédiaire",
    common_intensity_adv: "Avancé",
    common_no_more_data: "Plus aucune donnée",
    common_days: "jours",
  },
  workoutType: {
    Treadmill: "Tapis roulant",
    IndoorBike: "Vélo de salle",
    Elliptical: "Elliptique",
    Stepper: "Stepper",
    Rowing: "Rami",
    RowNRide: "Row-N-Ride",
    Cardio: "Cardio",
    Yoga: "Yoga",
    Strength: "Force",
    prenatal: "Prénatal",
    postpartum: "Post-partum",
    meditation: "Méditation",
    Audio: "Audio",
    Stretching: "Étirement",
    outdoorRunning: "course extérieure",
    outdoorCycling: "Cyclisme extérieur",
    outdoorWalking: "Marche en extérieur",
  },
};
export default lang;



// WEBPACK FOOTER //
// ./src/locales/fr.js